/* Amend dates format to use fn_fmtDt Oct 10, 2023 */
/* Amend to use opportunity photoURL June 21, 2025 */
<template>
  <b-row no-gutters class="py-2 card-content">
    <b-col cols="4" class="d-flex">
      <div
        class="d-flex flex-column align-items-start justify-content-start pl-2 pr-3"
      >
		<router-link :to="m_hrefVwRec('oppr', p_opportunity.opportunityNo )" > {{ p_opportunity.opportunityNo }}</router-link>
		<img v-if="p_opportunity.photoURL" id="addressImage"  class="mt-1" :src="p_opportunity.photoURL" @click="m_imageClick(p_opportunity)" />
		<img v-else id="addressImage"  class="mt-1" src="@/assets/SitePlaceHolder.jpg" @click="m_imageClick(p_opportunity)" />      
	   </div>
    </b-col>
    <b-col cols="8" class="border-left pl-1">
      <b-row cols="2" no-gutters class="text-left">
        <b-col cols="4">
          <p class="mb-0">
            <strong>Opportunity Name: </strong>
          </p>
        </b-col>
        <b-col cols="8">
          <p class="mb-0">{{p_opportunity.opportunityName }}</p>
        </b-col>
        <b-col cols="4">
          <p class="mb-0"><strong>Address:</strong></p>
        </b-col>
        <b-col cols="8">
          <p class="mb-0">
            {{ p_opportunity.streetAddress }},{{ p_opportunity.city }},{{
              p_opportunity.stateProvince
            }},{{ p_opportunity.zipCode }}
          </p>
        </b-col>
        <b-col cols="4">
          <p class="mb-0"><strong>Opportunity Status:</strong></p>
        </b-col>
        <b-col cols="8">
          <p class="mb-0">{{ p_opportunity.statusName }}</p>
        </b-col>
        <b-col cols="4">
          <p class="mb-0"><strong>Market Segment:</strong></p>
        </b-col>
        <b-col cols="8">
          <p class="mb-0">{{ p_opportunity.marketSegmentName }}</p>
        </b-col>
        <b-col cols="4">
          <p class="mb-0"><strong>Client:</strong></p>
        </b-col>
        <b-col cols="8">
          <p class="mb-0">{{ p_opportunity.clientName }}</p>
        </b-col>
        <b-col cols="4">
			<p class="mb-0"><strong>Project Size:</strong></p>
        </b-col>
        <b-col cols="8">
			<p class="mb-0 projectsize"><strong>{{d_projectSize}}</strong></p>
        </b-col>
		<b-col cols="4">
		<p class="mb-0"><strong>Project Value:</strong></p>
		</b-col>
		<b-col cols="8">
			<p class="mb-0 money"><strong>{{d_value}}</strong></p>
		</b-col>
        <b-col cols="4">
          <p class="mb-0"><strong>Due Date:</strong></p>
        </b-col>
        <b-col cols="8">
          <p class="mb-0">{{ d_dueDate }}</p>
        </b-col>
        <b-col cols="7">
          <p class="mb-0"><strong>Approx Construction Start Date:</strong></p>
        </b-col>
        <b-col cols="5">
          <p class="mb-0">{{ d_startDate }}</p>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import {fn_fmtDt,fn_fmtSf,fn_fmtMoney,fn_hrefVwRec} from "@/utils/util.js";
export default {
  name: "KTMapCard",
  props: {
    p_opportunity: Object,
  },
  data() {
    return {
		d_value:fn_fmtMoney(this.p_opportunity.value),
		d_projectSize:fn_fmtSf(this.p_opportunity.projectSize),
		d_startDate:fn_fmtDt(this.p_opportunity.approxConstructionStartDate),
		d_dueDate:fn_fmtDt(this.p_opportunity.dueDate),
		};
	},
  mounted(){ console.log('In MapCard');
			console.log(this.p_opportunity);
  },
  calculated:{
	c_value() {return fn_fmtSf(this.p_opportunity.projectSize);},
	c_projectSize() { return fn_fmtSf(this.p_opportunity.projectSize);},
	c_photoURL() {return this.p_opportunity.photoURL?this.p_photoRec.photoURL:sitePlaceHolder;},
	},
  methods:{
       m_hrefVwRec(recordType,recordNo){
		return fn_hrefVwRec(recordType,recordNo);
		},
       m_imageClick(p_opportunity){   
				console.log(`${p_opportunity.streetAddress},${p_opportunity.city},${p_opportunity.stateProvince}`);
				if(p_opportunity.streetAddress&&p_opportunity.city&&p_opportunity.stateProvince){
					console.log('Image Clicked');
					this.$emit('highlightMarker', p_opportunity.opportunityNo);
					}
					
		}
	},
watch:{
	p_opportunity(){
		
		this.d_value=fn_fmtMoney(this.p_opportunity.value);
		this.d_projectSize=fn_fmtSf(this.p_opportunity.projectSize);
		
		if(this.p_opportunity.photoURL)
			document.getElementById("addressImage").src = this.p_opportunity.photoURL;
		
		}
}
};
</script>

<style scoped lang="less">
.border-left {
  border-left: 4px solid black !important;
}
p {
  font-size: 13px;
}
.card-content:hover {
  border-bottom: 2px solid;
  border-top: 2px solid;
}
.money{
       color:blue;
	}
.projectsize{
		color:green;
}
img {width: 200px !important;
	height:125px !important;
	border-radius:8px !important;
}
</style>
